<Modal
    id="show-activation-elements-modal-id"
    bind:enabled={showPlanElementActivationConfirmModal}
    titleText={i18n.pleaseConfirm}
    bodyText={i18n.planElementActivationConfirmDialog_Message}
    confirmText={i18n.yes}
    cancelText={i18n.no}
    on:close={activationResourceConfirm}
/>
<Modal
    id="show-activation-folder-modal-id"
    bind:enabled={showPlanFolderActivationConfirmModal}
    titleText={i18n.pleaseConfirm}
    bodyText={resource.isActive
        ? formatLanguageString(
              i18n.folderDeactivateContentConfirmDialog_Description,
              resource.title
          )
        : formatLanguageString(i18n.folderActivateContentConfirmDialog_Description, resource.title)}
    confirmText={i18n.yes}
    cancelText={i18n.no}
    on:close={activationFolderConfirm}
    clickOutsideCloses={false}
/>

<Modal
    id="show-delete-element-confirm-modal-id"
    bind:enabled={showDeleteElementFromCourseConfirmModal}
    titleText={i18n.pleaseConfirm}
    bodyHtml={i18n.deleteFromCourseConfirmationMessage}
    confirmText={i18n.confirm}
    cancelText={i18n.cancel}
    on:close={deleteElementFromCourceConfirm}
    confirmButtonType="destructive"
    clickOutsideCloses={false}
/>

<li
    bind:this={mainElement}
    class="its-plans-resource__block"
    id={rowId !== undefined
        ? `resource-node-${rowId}-${resource.id}`
        : `resource-node-${resource.id}`}
    class:its-plans-resource__block--drag={reorderActive}
    class:its-plans-resource__block--hidden={hidden}
    role={keyboardReorder ? "option" : undefined}
    aria-labelledby={rowId !== undefined
        ? `its-plans-resource-${rowId}-${resource.id}`
        : `its-plans-resource-${resource.id}`}
    aria-selected={keyboardReorder ? reorderActive : undefined}
>
    {#if config.canEdit}
        <button
            id={rowId !== undefined
                ? `resource-node-${rowId}-${resource.id}-drag`
                : `resource-node-${resource.id}-drag`}
            class="its-plans-resource__drag"
            on:mousedown={mouseDownDragButton}
            on:touchstart={mouseDownDragButton}
            on:click={clickDragButton}
            on:keyup={keyUpDragButton}
            on:blur={blurDragButton}
            aria-labelledby={rowId !== undefined
                ? `its-plans-resource-${rowId}-${resource.id}`
                : `its-plans-resource-${resource.id}`}
            aria-pressed={reorderActive}
        />
        <div
            class="its-plans-resource__tooltip"
            aria-live="polite"
            class:its-plans-resource__tooltip--visible={tooltipVisible}
        >
            {#if tooltipVisible}
                <Tooltip
                    element={mainElement}
                    id={rowId !== undefined
                        ? `resource-${rowId}-${resource.id}-drag-tip`
                        : `resource-${resource.id}-drag-tip`}
                    placement="left"
                    role="tooltip"
                    show={tooltipVisible}
                    text={i18n.elementDragHandleTooltip}
                />
            {/if}
        </div>
    {/if}
    {#if (!config.publicAccessKey && !isParent && (config.isLearner || config.canEdit || config.isGuest) || (isParent && config.isParentAllowedToClickCourseContent))}
        <a
            id={rowId !== undefined
                ? `its-plans-resource-${rowId}-${resource.id}`
                : `its-plans-resource-${resource.id}`}
            class="its-plans__resource-node"
            class:its-plans__resource-node--inactive={!resource.isActive}
            href={url}
            target={"_self"}
        >
            {#if !config.canEdit && resource.type !== "Folder"}
                <ElementProgress complete={resource.isCompleted} {i18n} />
            {/if}

            <span
                class="its-plans-resource__icon {!config.canEdit && resource.type === 'Folder'
                    ? 'its-plans-resource__icon_folder'
                    : ''}"
                style={iconStyle}
                aria-hidden="true"
            />
            <span class="its-plans-resource__name">
                {resource.title}
            </span>
            {#if !resource.isActive}
                <span class="its-plans-resource__hidden-icon">
                    <span class="screen-reader">{i18n.hidden}</span>
                </span>
            {/if}
            {#if config.canEdit && !planResources && resource.totalCount > 0 && !isMobile()}
                <ElementProgressCount
                    doneCount={resource.doneCount}
                    totalCount={resource.totalCount}
                    accessibleText={i18n.xOfYCompleted}
                />
            {/if}
        </a>
    {:else}
        <span
            id={rowId !== undefined
                ? `its-plans-resource-${rowId}-${resource.id}`
                : `its-plans-resource-${resource.id}`}
            class="its-plans__resource-node"
        >
            <span class="its-plans-resource__icon" style={iconStyle} aria-hidden="true" />
            <span class="its-plans-resource__name">
                {resource.title}
            </span>
        </span>
    {/if}

    <div class="its-plans__resource-node-focus-helper" />
    <div bind:this={resourcesOptions} class="its-plans-resource__options">
        {#if config.canEdit}
            <ButtonDropdown
                expanded={false}
                iconClass="options-icon"
                iconOnly={true}
                id={rowId !== undefined
                    ? `optionsdropdown-${rowId}-${resource.id}`
                    : `optionsdropdown-${resource.id}`}
                text={i18n.resourceOptions}
                responsive={false}
                items={getDropDownItems(resource.isActive)}
                textOnly={false}
                type="plain"
                on:selectedOption={selectedOptionAction}
            />
        {/if}
    </div>

    {#if showHomeworkMarker}
        <div class="its-plan-resource_marker">
            {i18n.homework.toLocaleUpperCase(config.locale)}
        </div>
        <span role="img" aria-label={i18n.homework} class="its-plan-resource_marker-icon" />
    {/if}
</li>

<script>
    import config from "../../config";
    import i18n from "../../i18n";
    import ElementProgress from "../ElementProgress/ElementProgress.svelte";
    import ElementProgressCount from "../ElementProgressCount/ElementProgressCount.svelte";
    import ButtonDropdown from "@itslearning/prometheus/assets/dropdowns/ButtonDropdown/v1/ButtonDropdown.svelte";
    import Tooltip from "@itslearning/prometheus/assets/modals/Tooltip/v1/Tooltip.svelte";
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import { createEventDispatcher } from "svelte";
    import { Keys } from "@itslearning/atlas/keyboard/keys";
    import { normalizeKey } from "@itslearning/atlas/keyboard/normalize";
    import { getElementUsageCount } from "../../api.js";
    import { formatLanguageString } from "@itslearning/atlas/strings/format";
    import { isMobile } from "@itslearning/atlas/detectors/UserAgentHelper";
    import { addBackDestinationParam } from "../../helpers/backLinkHelper";

    export let resource;
    export let hidden;
    export let reorderActive;
    export let keyboardReorder;
    export let isParent;
    export let rowId;
    export let elementsUrlExtraParams;
    export let numberOfPlansInCourse;

    export let planResources = undefined;

    const dispatch = createEventDispatcher();

    let mainElement;
    let tooltipVisible = false;
    let showPlanElementActivationConfirmModal = false;
    let showPlanFolderActivationConfirmModal = false;
    let showDeleteElementFromCourseConfirmModal = false;
    let resourcesOptions;

    $: showHomeworkMarker = resource.isHomework && config.isLearner;
    $: iconStyle = `background-image: url(${resource.brandIconUrl || resource.iconUrl});`;
    $: url = addBackDestinationParam(resource.planPageUrl, elementsUrlExtraParams);

    function getDropDownItems(activeElement) {
        const optionsArray = [
            {
                options: [
                    {
                        icon: "",
                        label: i18n.removeFromPlan,
                        link: false,
                        target: "_self",
                        value: { source: "Remove" }
                    },
                    {
                        icon: "",
                        label: activeElement ? i18n.resourceDeactivate : i18n.resourceActivate,
                        link: false,
                        target: "_self",
                        value: { source: "ToggleActivation" }
                    }
                ]
            }
        ];

        if (
            (config.isResourcesCourseMenuVisible &&
                config.allowUsersToggleResourcesInCourseSettings) ||
            !config.allowUsersToggleResourcesInCourseSettings
        ) {
            optionsArray[0].options.splice(1, 0, {
                icon: "",
                label: i18n.deleteFromCourse,
                link: false,
                target: "_self",
                value: { source: "DeleteFromCourse" }
            });
        }

        if (numberOfPlansInCourse > 1) {
            optionsArray[0].options.splice(0, 0, {
                icon: "",
                label: i18n.moveToAnotherPlan,
                link: false,
                target: "_self",
                value: { source: "MoveTo" }
            });
        }

        return optionsArray;
    }

    function selectedOptionAction(event) {
        const data = event.detail.data;

        switch (data.source) {
            case "MoveTo":
                dispatch("showMoveToModal", { showModal: true });
                break;
            case "Remove":
                dispatch("removeElementFromPlan", {
                    resourceId: resource.id
                });
                break;
            case "DeleteFromCourse":
                showDeleteElementFromCourseConfirmModal = true;
                break;
            case "ToggleActivation":
                if (resource.type === "Folder") {
                    showPlanFolderActivationConfirmModal = true;
                } else {
                    getElementUsageCount(resource.id).then(response => {
                        if (response && response.ElementUsageCount > 1) {
                            showPlanElementActivationConfirmModal = true;
                        } else {
                            dispatch("toggleElementActivation", {
                                id: resource.id,
                                activate: !resource.isActive,
                                isFolder: false,
                                changeActivationForFolderContent: false
                            });
                        }
                    });
                }

                break;
        }
    }

    function mouseDownDragButton(e) {
        dispatch("dragStart", e);
    }

    function clickDragButton(e) {
        dispatch("keyboardDragStart", e);
    }

    function keyUpDragButton(e) {
        if (normalizeKey(e.key) === Keys.TAB) {
            tooltipVisible = true;
        }
    }

    function blurDragButton() {
        tooltipVisible = false;
    }

    function activationResourceConfirm(event) {
        if (event.detail.confirmed === true) {
            dispatch("toggleElementActivation", {
                id: resource.id,
                activate: !resource.isActive,
                isFolder: false,
                changeActivationForFolderContent: false
            });
        }

        showPlanElementActivationConfirmModal = false;
    }

    function activationFolderConfirm(event) {
        if (event.detail.confirmed === true) {
            dispatch("toggleElementActivation", {
                id: resource.id,
                activate: !resource.isActive,
                isFolder: true,
                changeActivationForFolderContent: event.detail.confirmed === true
            });
        }

        showPlanFolderActivationConfirmModal = false;
    }

    document.addEventListener("keydown", keyDownTextField, false);

    function keyDownTextField(e) {
        const section = document.querySelector('section[aria-expanded="true"]');

        if (normalizeKey(e.key) === Keys.TAB && section !== null) {
            section.previousElementSibling.click();
        }
    }

    function deleteElementFromCourceConfirm(event) {
        if (event.detail.confirmed === true) {
            dispatch("removeElementFromCourse", {
                resourceId: resource.id
            });
        }

        showDeleteElementFromCourseConfirmModal = false;
    }
</script>
